import { jsx, Fragment } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import useIsMobile from "../../hooks/use-is-mobile.es.js";
import { styled } from "@mui/material";
import { NavigationListItemCollapsible, NavigationListItem } from "./navigation-list-item.es.js";
import List$1 from "../../../node_modules/@mui/material/List/List.es.js";
import { Displaying } from "../../foundations/displaying.es.js";
import { Direction } from "../../foundations/direction.es.js";
const NestedNavigation = function({
  navigationItems
}) {
  function renderNavigationItems(items) {
    return items.map(function toNavigationItem(item) {
      return item.subpaths ? /* @__PURE__ */ jsx(NavigationListItemCollapsible, { ...item, children: /* @__PURE__ */ jsx(NavigationList, { children: renderNavigationItems(item.subpaths) }) }, item.label) : /* @__PURE__ */ jsx(NavigationListItem, { ...item }, item.label);
    });
  }
  return /* @__PURE__ */ jsx(Fragment, { children: renderNavigationItems(navigationItems) });
};
const NavigationList = function(props) {
  const isMobile = useIsMobile();
  return /* @__PURE__ */ jsx(List, { ...props, sx: {
    gap: isMobile ? 1 : 2
  } });
};
const List = styled(List$1)({
  display: Displaying.flex,
  flexDirection: Direction.column
});
export {
  NavigationList,
  NestedNavigation
};
//# sourceMappingURL=navigation-list.es.js.map
